import { NgStyle } from '@angular/common';
import { Component, Input } from '@angular/core';
import { DefaultStyleDirective } from '../../../flex-layout/style';
import { CommonService } from '../../../services/common.service';
import { EditorTextComponent } from '../editor-text/editor-text.component';

@Component({
  selector: 'calsoft-textwithimage',
  imports: [EditorTextComponent,NgStyle, DefaultStyleDirective],
  templateUrl: './textwithimage.component.html',
  styleUrl: './textwithimage.component.scss'
})
export class TextwithimageComponent {

   @Input() item: any;
  @Input() data: any;
  customField18:any;
  customField17:any;

  constructor(
    private commonService: CommonService,
  ) {

  }

}
